export const familyAccount ={
    HEB: {

        myFamily: "המשפחה שלי",
        inviteMembers: "הזמנת חברי משפחה",
        inviteSuccessText: {
            header: "הזמנה נשלחה בהצלחה",
            details: "הזמנה נשלחה ל:", 
            button: "סגור",
        },
        inviteFailText: {
            header: "שליחת הזמנה נכשלה",
            details: "שליחת הזמנה נכשלה ל", 
            button: "סגור",
        },
        familyName: "שם המשפחה",
        inviteButton: "הזמן",
        joinedOn: "הצטרף בתאריך",
        familyMembersTitle: " חברי המשפחה שלי",
        family: "משפחת",
        youDontBelongToAFamily: " אינך משוייך כרגע למשפחה, כדי לייצר משפחה - שלח הזמנה או קבל ואשר הזמנה נכנסת  ",
        save: "שמור",
        editFamilyName: "עריכת שם משפחה",
        invitedOn: "הוזמן בתאריך",
        pendingInvites: "הזמנות פתוחות ששלחתי",
        incomingFamilyRequest: "הוזמנת למשפחת",
        by: "על ידי",
        rejectedInvite: "הזמנה נדחתה למשפחת",
        errorRejectingInvite: "שגיאה בדחיית הזמנה למשפחת",
        acceptedInvite: "הצטרפת בהצלחה למשפחת",
        errorAcceptingInvite: "שגיאה באישור הזמנה למשפחת",
        reject: "דחה",
        accept: "אשר",
        familyInvite:{
            header: "הוספת התא המשפחתי",
            body: "כאן תוכלו להוסיף את בן או בת הזוג של התא המשפחתי על מנת להתנהל כלכלית יחד. שלחו הזמנה ובקשו מבן או בת הזוג להיכנס באמצעות אותה כתובת מייל. ניתן לבטל את השיתוף בכל עת.",
            checkboxText: "אני מאשר/ת כי אני משתפ/ת את המידע הפיננסי שלי על פי החלטתי עם אדם איתו אני מקיימ/ת משק בית ו/או תא משפחתי בלבד.",
            familyVerificationError: "יש לאשר את הסעיף כדי להמשיך",
        }
    }
}